import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import SpaIcon from '@mui/icons-material/Spa';
import { useNavigate } from 'react-router-dom';

export default function Welcome() {
  const navigate = useNavigate();
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      return null;
    }
  })();

  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.reload();
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#f4faef',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 2
    }}>
      <Paper elevation={4} sx={{
        p: 4,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 380,
        width: '100%',
        bgcolor: 'white',
        mb: 4
      }}>
        <SpaIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        <Typography variant="h4" fontWeight={700} color="primary" align="center" mb={1}>
          ¡Bienvenido a GreenBalance!
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" mb={3}>
          Tu app para comer más vegetales, de forma fácil y divertida 🍃
        </Typography>
        {user ? (
          <>
            <Typography variant="h6" color="primary" align="center" mb={2}>
              ¡Hola, {user.full_name || user.email}!
            </Typography>
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              sx={{ borderRadius: 3, fontWeight: 700, fontSize: '1.1rem', mb: 2, py: 1.5 }}
              onClick={() => navigate('/profile')}
            >
              Ir a mi perfil
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              fullWidth
              sx={{ borderRadius: 3, fontWeight: 700, fontSize: '1.1rem', py: 1.5 }}
              onClick={handleLogout}
            >
              Cerrar sesión
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              size="large"
              fullWidth
              sx={{ borderRadius: 3, fontWeight: 700, fontSize: '1.1rem', mb: 2, py: 1.5 }}
              onClick={() => navigate('/login')}
            >
              Iniciar sesión
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              fullWidth
              sx={{ borderRadius: 3, fontWeight: 700, fontSize: '1.1rem', py: 1.5 }}
              onClick={() => navigate('/user-register')}
            >
              Crear cuenta
            </Button>
          </>
        )}
      </Paper>
      <Typography variant="body2" color="text.secondary" align="center">
        © {new Date().getFullYear()} GreenBalance
      </Typography>
    </Box>
  );
} 